import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const Services = () => {
  return (
    <div className="services-page">
      <section className="about-hero">
        <h1 className="hero-title">
          <span className="gradient-text">Our Services</span>
        </h1>
        <p className="tagline">
          Comprehensive solutions for every digital need. From concept to launch and beyond.
        </p>
      </section>

      <section className="section">
        <div className="services-grid">
          <div className="service-card glass">
            <div className="service-number">01</div>
            <h3 className="service-title">Web Design & UX</h3>
            <p className="service-desc">
              Beautiful, intuitive interfaces that users love. We blend aesthetics with usability to create
              experiences that convert visitors into customers.
            </p>
            <ul className="service-features">
              <li>Custom UI/UX Design</li>
              <li>Interactive Prototypes</li>
              <li>Design Systems</li>
              <li>Brand Identity Integration</li>
              <li>User Research & Testing</li>
            </ul>
          </div>

          <div className="service-card glass">
            <div className="service-number">02</div>
            <h3 className="service-title">Web Development</h3>
            <p className="service-desc">
              Cutting-edge development that brings designs to life. We build fast, secure, scalable websites
              using the latest technologies.
            </p>
            <ul className="service-features">
              <li>React & Next.js Development</li>
              <li>E-commerce Solutions</li>
              <li>CMS Integration</li>
              <li>API Development</li>
              <li>Performance Optimization</li>
            </ul>
          </div>

          <div className="service-card glass">
            <div className="service-number">03</div>
            <h3 className="service-title">Full-Stack Solutions</h3>
            <p className="service-desc">
              End-to-end development for complex applications. From database architecture to front-end interfaces,
              we handle every layer of your digital product.
            </p>
            <ul className="service-features">
              <li>Custom Web Applications</li>
              <li>Database Design</li>
              <li>Cloud Infrastructure</li>
              <li>Third-party Integrations</li>
              <li>Scalable Architecture</li>
            </ul>
          </div>

          <div className="service-card glass">
            <div className="service-number">04</div>
            <h3 className="service-title">AI Integration</h3>
            <p className="service-desc">
              Harness the power of artificial intelligence to transform your business. We integrate cutting-edge AI
              technologies to automate processes, enhance user experiences, and unlock new possibilities.
            </p>
            <ul className="service-features">
              <li>AI-Powered Chatbots & Virtual Assistants</li>
              <li>Natural Language Processing (NLP)</li>
              <li>Predictive Analytics & Insights</li>
              <li>Computer Vision Integration</li>
              <li>Machine Learning Models</li>
              <li>Agentic AI</li>
            </ul>
          </div>

          <div className="service-card glass">
            <div className="service-number">05</div>
            <h3 className="service-title">Interactive Experiences</h3>
            <p className="service-desc">
              Immersive 3D and animated experiences that captivate audiences. We push the boundaries of what's
              possible in the browser with WebGL and advanced animations.
            </p>
            <ul className="service-features">
              <li>Three.js & WebGL</li>
              <li>Advanced Animations (GSAP)</li>
              <li>Interactive Storytelling</li>
              <li>Scroll-based Experiences</li>
              <li>Particle Systems</li>
            </ul>
          </div>

          <div className="service-card glass">
            <div className="service-number">06</div>
            <h3 className="service-title">SEO & Performance</h3>
            <p className="service-desc">
              Get found and stay fast. We optimize every aspect of your site for search engines and lightning-fast
              load times that keep users engaged.
            </p>
            <ul className="service-features">
              <li>Technical SEO Audit</li>
              <li>Core Web Vitals Optimization</li>
              <li>Schema Markup</li>
              <li>Speed Optimization</li>
              <li>Analytics Integration</li>
            </ul>
          </div>

          <div className="service-card glass">
            <div className="service-number">07</div>
            <h3 className="service-title">Maintenance & Support</h3>
            <p className="service-desc">
              Your website is never "done." We provide ongoing support, updates, and improvements to keep your
              digital presence fresh and secure.
            </p>
            <ul className="service-features">
              <li>24/7 Monitoring</li>
              <li>Security Updates</li>
              <li>Content Updates</li>
              <li>Performance Monitoring</li>
              <li>Feature Enhancements</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <h2 className="cta-title">
          Let's Build <span className="gradient-text">Something Amazing</span>
        </h2>
        <p className="cta-subtitle">
          Choose the services you need, or let us create a custom package tailored to your goals.
        </p>
        <Link to="/contact" className="cta-button">Get Started</Link>
      </section>
    </div>
  );
};

export default Services;
